import { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface ExpertReportSubtitleProps {
  children: ReactNode
}

export const ExpertReportSubtitle = ({ children }: ExpertReportSubtitleProps): ReactElement => (
  <Styled.ExpertReportSubtitleWrapper>{children}</Styled.ExpertReportSubtitleWrapper>
)
